import React from 'react';
import { exportCSVFile } from '../../../lib/utils';
import FadeOutErrorMessage from '../util/FadeOutErrorMessage';

export default class ExportButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            exporting: false,
            error: false,
            errorMessage: ''
        }
    }

    async exportData() {
        this.setState({ exporting: true, error: false });

        try {
            const response = await this.props.getDataForExport();
            if (!response.success) {
                throw Error(response.message);
            }

            if(!response.data.length) {
                this.setState({ exporting: false, error: true, errorMessage: 'No results for export' });
            } else {
                const headers = this.props.exportHeaders || this.props.getDynamicExportHeaders(response.data);
                exportCSVFile(headers, response.data, `${this.props.fileName}-${new Date().toLocaleDateString().replace(/\//g, "-")}`);
    
                this.setState({ exporting: false });
                if (this.props.onGetDataSuccess) {
                    this.props.onGetDataSuccess();
                }
            }
        } catch (error) {
            this.setState({ exporting: false, error: true, errorMessage: error.message });
        }
    }

    //added this.props.exporting & this.props.error to allow management of export via redux store 
    //bec long exports may extend over mounting and unmounting of component and loses component state
    //use redux storage going forward
    render() {
        const buttonText = (this.state.exporting || this.props.exporting) ? (this.props.busyText || "Exporting...") : (this.props.text || "Export");
        const isSelectionBtn = this.props.buttonClassName && this.props.buttonClassName.includes('selection-action-btn');

        return (
            <div>
                <button className={`btn btn-flat btn-small ${this.props.buttonClassName || ''}`.trim()}
                    onClick={this.exportData.bind(this)}
                    disabled={this.props.disabled || this.state.exporting}
                    title={this.props.title}>
                    {this.props.count !== undefined && !(this.state.exporting || this.props.exporting)
                        ? <span>
                            <span className="selection-action-btn__content">
                                <img
                                    src={`/images/export-icon${(this.props.disabled || this.state.exporting) ? "-disabled" : ""}.png`}
                                    className="selection-action-btn__icon"
                                    alt="export-icon"
                                />
                                <span className="selection-action-btn__label">{buttonText}</span>
                            </span>
                            {isSelectionBtn && <span className="selection-action-btn__badge">{this.props.count}</span>}
                            {!isSelectionBtn && <span>({this.props.count})</span>}
                        </span>
                        : <span>
                            <img
                                src={`/images/export-icon${(this.props.disabled || this.state.exporting) ? "-disabled" : ""}.png`}
                                className="icon-left"
                                alt="export-icon"
                            />
                            {buttonText}
                        </span>}
                </button>
                <FadeOutErrorMessage show={(this.state.error || this.props.error)} message={this.state.errorMessage} timeOut={5000} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/shared/ExportButton.jsx